<template>
  <div class="menzhenjiaofei">
    <noData />
    <van-tabs v-if="false" v-model="activeName">
      <van-tab title="待缴费" name="1">
        <van-list
          v-model="waitLoading"
          :finished="waitFinished"
          finished-text="已经到底了"
          :immediate-check="false"
          @load="waitOnLoad"
        >
          <mzjfList :list="waitList" @checkChange="checkChange" />
        </van-list>
        <div class="menzhenjiaofei-btn">
          <van-button :loading="payLoading" class="bottom-btn" type="info" @click="pay">立即支付</van-button>
        </div>
      </van-tab>
      <van-tab title="全部" name="2">
        <menzhenjiaofeijilu />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import menzhenjiaofeijilu from '../menzhenjiaofeijilu/menzhenjiaofeijilu.vue'
import mzjfList from './list'
export default {
  name: 'MenZhenJiaoFei',
  components: {
    mzjfList,
    menzhenjiaofeijilu
  },
  data() {
    return {

      userId: '',
      activeData: [],
      item: {},
      activeName: '1',
      waitList: [],
      allList: [],
      allCurrent: 1,
      waitCurrent: 1,
      pageSize: 10,
      waitLoading: false,
      allLoading: false,
      waitFinished: false,
      allFinished: false,
      payLoading: false,
      onLoad: ''
    }
  },
  created() {
    this.userId = this.$route.query.id || ''
    this.getChargeListPage(1)
    // setTimeout(() => {
    //   this.getChargeListPage(2)
    // }, 2000)
  },
  mounted() {},
  methods: {
    getChargeListPage(type) {
      if (type === 1) {
        this.waitLoading = true
      } else {
        this.allLoading = true
      }
      const obj = {
        current: type === 1 ? this.waitCurrent : this.allCurrent,
        size: this.pageSize,
        patientIds: this.userId,
        status: type === 1 ? 0 : ''
      }
      this.$Apis.chargeListPage(obj).then(res => {
        if (type === 1) {
          this.waitLoading = false
        } else {
          this.allLoading = false
        }
        if (res.code === 200) {
          if (type === 1) {
            this.waitList = [...this.waitList, ...res.data.list]
            this.waitFinished = (res.data.totalPage === 0 || res.data.totalPage === this.waitCurrent)
          } else {
            this.allList = [...this.allList, ...res.data.list]
            this.allFinished = (res.data.totalPage === 0 || res.data.totalPage >= this.allCurrent)
          }
        } else {
          if (type === 1) {
            this.waitFinished = true
          } else {
            this.allFinished = true
          }
        }
      }).catch(() => {
        if (type === 1) {
          this.waitFinished = true
          this.waitLoading = false
        } else {
          this.allFinished = true
          this.allLoading = false
        }
      })
    },
    waitOnLoad() {
      this.waitCurrent++
      this.getChargeListPage(1)
    },
    onLoadAll() {
      this.allCurrent++
      this.getChargeListPage(2)
    },
    checkChange(item) {
      if (item.checked) {
        this.activeData.push(item.id)
      } else {
        const index = this.activeData.findIndex(t => t === item.id)
        this.activeData.splice(index, 1)
      }
    },
    pay() {
      if (this.activeData.length === 0) return
      const data = {
        ids: this.activeData.join(','),
        patientId: this.userId
      }
      this.payLoading = true
      this.$Apis.gjyyPay(data).then(res => {
        this.payLoading = false
        if (res.code === 200) {
          location.href = res.data
        } else {
          this.$toast(res.message)
        }
      }).catch(err => {
        this.payLoading = false
        this.$toast(err.message)
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
@import '~@/assets/css/common';
.menzhenjiaofei{
  padding-bottom: .6rem;
  &-btn{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: .1rem 0 .2rem;
    background: @background;
    .bottom-btn{
      border-radius: .25rem;
      margin: 0 auto;
      display: block;
      width: 90%;
    }
  }
}

  /deep/.van-tabs__line{
    background-color: #2B8CFF;
  }
  /deep/.van-tab--active{
    color: #2B8CFF;
  }
</style>
